import BasicTenantForm from './BasicTenantForm';

export default BasicTenantForm;
